/** @date - принимает дату из new Date и преобразует её в строку (21.08.2023) */
export const { format: formatDate } = Intl.DateTimeFormat('ru', { dateStyle: 'short' });
